import { render } from "./FormView.vue?vue&type=template&id=64510c88&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=64510c88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64510c88"]])

export default __exports__